const cards = [
  {
    tag: "Revenue Risk",
    title: "Revenue Risk",
    body:
      "AI security or control gaps can stall enterprise deals, customer reviews, procurement approvals, and trust-based sales cycles, long before the technical risk ever becomes an incident.",
    consequence: "Impact: deals slip while AI evidence is assembled under pressure.",
  },
  {
    tag: "Operational Risk",
    title: "Operational Risk",
    body:
      "AI agents and workflows can fail silently, take the wrong action, expose the wrong data, or create manual rework when ownership, approvals, and controls are unclear.",
    consequence: "Impact: silent failures and rework hide inside automated workflows.",
  },
  {
    tag: "Compliance & Trust Risk",
    title: "Compliance & Trust Risk",
    body:
      "AI touching PHI, PII, customer records, internal documents, or regulated workflows can create exposure the business is not prepared to defend under external scrutiny.",
    consequence: "Impact: exposure surfaces during the review you cannot reschedule.",
  },
  {
    tag: "Scale Risk",
    title: "Scale Risk",
    body:
      "AI that is useful in a pilot can become dangerous at scale if access, logging, approvals, monitoring, and rollback are not validated before broader rollout.",
    consequence: "Impact: pilot-grade controls fail under production-scale use.",
  },
];

export default function ArqProblem() {
  return (
    <section className="bg-arq-surface1 py-20 md:py-[120px] px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center max-w-[820px] mx-auto mb-16">
          <div className="arq-label mb-6">The Evidence Gap</div>
          <h2 className="font-display font-semibold text-arq-text mb-6" style={{ fontSize: "clamp(28px, 4vw, 40px)", lineHeight: 1.2 }}>
            AI Is Already in Production. The Evidence Often Is Not.
          </h2>
          <p className="text-arq-muted text-[17px] leading-[1.75] max-w-[720px] mx-auto">
            Most teams cannot clearly prove what their AI systems expose, how they are controlled,
            what has been remediated, or what evidence exists for external review. That gap is
            the business risk.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((c) => (
            <div key={c.title} className="arq-card p-7">
              <h3 className="font-display text-[18px] font-semibold text-arq-text mb-3">
                {c.title}
              </h3>
              <p className="text-arq-muted text-[14.5px] leading-[1.65]">{c.body}</p>
              <p className="text-[11.5px] font-mono text-arq-tertiary mt-4 leading-[1.5]">{c.consequence}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
